// Order is used for language picker
export enum Languages {
	DA = 'da',
	EN = 'en',
	IT = 'it',
	FI = 'fi',
	FR = 'fr',
	DE = 'de',
	NO = 'no',
	ES = 'es',
}

export enum I18Namespaces {
	DEFAULT = 'translation',
	ADMIN_DASHBOARD = 'admin_dashboard',
	AUTH = 'auth',
	NOT_FOUND = '404',
	COMMON_FORM = 'common-form',
	COMMON_UI = 'common-ui',
	DOCUMENT_LIBRARY = 'document-library',
	MIP_MESSAGES = 'mip-messages',
	MIP_CREATE = 'mip-create',
	MIP_MANAGE = 'mip-manage',
	CAP_CREATE = 'cap-create',
	CAP_MANAGE = 'cap-manage',
	CAP_TABLE = 'cap-table',
	CAP_CHART = 'cap-chart',
	INVESTOR = 'investor',
	TERMS = 'terms',
	EXPORTS = 'exports',
	USER_PROFILES = 'user-profiles',
	ORGANIZATION = 'organization',
	VALUATIONS = 'valuations',
	HELP_BLOG = 'help-blog',
}
